// Chính sách mật khẩu mạnh — PHẢI khớp happyschool-api/src/passwordPolicy.js (server mới là nơi quyết định; đây chỉ để báo lỗi sớm).
export const PASSWORD_POLICY_TEXT = "Ít nhất 8 ký tự, gồm chữ hoa, chữ thường và chữ số, không chứa số điện thoại.";
const COMMON = new Set(["password1", "password123", "matkhau123", "matkhau1", "admin1234", "abcd1234", "qwerty123", "welcome123", "saolait123"]);
export function weakPasswordReason(password, phone) {
  const p = String(password || "");
  if (p.length < 8) return "Mật khẩu phải có ít nhất 8 ký tự.";
  if (!/[a-z]/.test(p)) return "Mật khẩu phải có ít nhất 1 chữ thường (a–z).";
  if (!/[A-Z]/.test(p)) return "Mật khẩu phải có ít nhất 1 chữ hoa (A–Z).";
  if (!/\d/.test(p)) return "Mật khẩu phải có ít nhất 1 chữ số (0–9).";
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length >= 6 && p.replace(/\D/g, "").includes(digits)) return "Mật khẩu không được chứa số điện thoại.";
  if (COMMON.has(p.toLowerCase()) || /^(.)\1+$/.test(p)) return "Mật khẩu quá dễ đoán, hãy chọn mật khẩu khác.";
  return null;
}
